import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ChartProgressionData from '../charts/ChartProgressionData';
import ChartStrategyExecData from '../charts/ChartStrategyExecData';
import CollapseContainer from '../FeedBackSynthesis/CollapseContainer';
import ChartOpinionOnValuation from '../charts/ChartOpinionOnValuation';
import ChartUnderval from '../charts/ChartUnderVal';
import ChartOpinionOnValuationData from '../charts/ChartOpinionOnValuationData';
import ChartUndervalData from '../charts/ChartUnderValData';
import ChartOverValData from '../charts/ChartOverValData';
import ChartMethodologiesData from '../charts/ChartMethodologiesData';
import ChartInfluencesData from '../charts/ChartInfluencesData';
import ChartValuationRetainedData from '../charts/ChartValuationRetainedData';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 1280,
    margin: '0 auto'
  },
  chartsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 30
  },
  subChartsContainer: {
    margin: '30px auto',
    textAlign: 'left'
  },
  title: {
    margin: '20px 0',
    fontSize: 22,
    textAlign: 'left'
  },
  subTitle: {
    margin: '20px 0',
    fontSize: 18,
    textAlign: 'left'
  },
  reasons: {
    flex: 0.3,
    marginRight: 15
  }
}));

const Valuation = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <CollapseContainer>
        <h3 className={classes.title}>Investors Valuation</h3>
        <div className={classes.chartsContainer}>
          <ChartOpinionOnValuationData />
          <div className={classes.reasons}>
            {/* <ChartOverValData />
            <ChartUndervalData /> */}
          </div>
        </div>
        <div className={classes.subChartsContainer}>
          <div className={classes.chartsContainer}>
            <ChartMethodologiesData />
            <ChartInfluencesData />
          </div>
          <ChartValuationRetainedData />
        </div>
      </CollapseContainer>
    </div>
  );
};

export default Valuation;
